var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /*
        jshint esversion: 6
        */

        /**
         * $
         */
        var HotelPageDesktop = function () {
            function HotelPageDesktop() {
                _classCallCheck(this, HotelPageDesktop);

                this.modal = window.modal;
                this.showToursFabObserver = null;
                this.showToursFabInitObserver = null;
                this.showToursFabResultsObserver = null;
                this.hotelHotOffersSwipers = [];

                this.handlers();
                this.showExpiredTourNotice();
            }

            _createClass(HotelPageDesktop, [{
                key: "showExpiredTourNotice",
                value: function showExpiredTourNotice() {
                    var _this = this;

                    var template = document.getElementById('expiredTourNoticeTemplate');
                    if (!template) return;
                    var show = function show() {
                        var form = document.querySelector('.ng-hotel-tours-wrapper app-short-search-params');
                        if (!form) return false;
                        form.classList.add('expired-tour-anchor');
                        form.appendChild(template.content.cloneNode(true));
                        var notice = form.querySelector('.expired-tour-notice');
                        if (window.brxTracking) window.brxTracking.sendAnalyticsEvent('hotel_expired_tour_notice_show', Object.assign({}, window.app && window.app.pageParams));
                        var blurred = _this.focusExpiredTourForm(form);
                        var dismiss = function dismiss() {
                            notice.remove();
                            form.classList.remove('expired-tour-anchor');
                            blurred.forEach(function (element) {
                                return element.classList.remove('expired-tour-blurred');
                            });
                        };
                        notice.querySelector('.expired-tour-notice__close').addEventListener('click', dismiss);
                        window.setTimeout(function () {
                            window.scrollTo({
                                top: window.scrollY + form.getBoundingClientRect().top - notice.offsetHeight - 24,
                                behavior: 'smooth'
                            });
                        }, 600);
                        return true;
                    };
                    if (show()) return;
                    var observer = new MutationObserver(function () {
                        if (show()) observer.disconnect();
                    });
                    observer.observe(document.querySelector('app-root'), { childList: true, subtree: true });
                }
            }, {
                key: "focusExpiredTourForm",
                value: function focusExpiredTourForm(form) {
                    var blurred = [];
                    var branch = form;
                    while (branch.parentElement) {
                        var parent = branch.parentElement;
                        Array.from(parent.children).forEach(function (element) {
                            if (element === branch || ['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE'].includes(element.tagName)) return;
                            element.classList.add('expired-tour-blurred');
                            blurred.push(element);
                        });
                        if (parent === document.body) break;
                        branch = parent;
                    }
                    return blurred;
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    $event.addEvent('click', '.js-show-hotel-description', function () {
                        var scrollToElement = QS('#hotelDescriptionText');

                        if (!scrollToElement) {
                            return;
                        }

                        window.scrollTo({
                            top: scrollToElement.getBoundingClientRect().top + window.scrollY - 50,
                            behavior: 'smooth'
                        });

                        var eventProperties = { Page: app.pageType };
                        window.brxTracking.sendAnalyticsEvent('click_more_details_about_hotel', eventProperties);

                        _this2.hotelServicesToggle(QS('.js-hotel-service-toggle'));
                    }).on('click', '.js-show-tours-link', function (event, target) {
                        event.preventDefault();
                        var fabButton = target.closest ? target.closest('.hotel-tours-fab') : null;

                        window.brxTracking.sendAnalyticsEvent('click_show_tours');

                        if (fabButton) {
                            var scrollToElement = document.querySelector('.ng-hotel-tours-wrapper');

                            if (scrollToElement) {
                                window.scrollTo({
                                    top: scrollToElement.getBoundingClientRect().top + window.scrollY - 16,
                                    behavior: 'smooth'
                                });
                            }

                            return;
                        }

                        var url = target.dataset.url;
                        var params = target.dataset.params;

                        if (window.showPageLoader) {
                            window.showPageLoader();
                        }

                        window.location.href = url + (params ? '?' + params : '');
                    }).on('click', '.hotel-tours-fab', function (event) {
                        event.preventDefault();

                        window.brxTracking.sendAnalyticsEvent('click_show_tours');

                        var scrollToElement = document.querySelector('.ng-hotel-tours-wrapper');

                        if (!scrollToElement) {
                            return;
                        }

                        window.scrollTo({
                            top: scrollToElement.getBoundingClientRect().top + window.scrollY - 16,
                            behavior: 'smooth'
                        });
                    }).on('click', '.btn-show-map', function () {
                        _this2.openModal();
                    }).on('click', '.js-offer-of-day-card', function (event, target) {
                        if (event.target.closest('.offer-of-day-card-link-btn')) {
                            return;
                        }

                        var card = target.closest('.js-offer-of-day-card');
                        if (!card || !card.dataset.url) {
                            return;
                        }

                        if (window.showPageLoader) {
                            window.showPageLoader();
                        }

                        window.location.href = card.dataset.url;
                    }).on('click', '.js-hotel-service-toggle', function (event, target) {
                        _this2.hotelServicesToggle(target);
                    });

                    var self = this;
                    document.addEventListener('DOMContentLoaded', function () {
                        self.animateGradeBars();
                        self.initHotelDescriptionClamp();
                        self.initHotelInfoClamp();
                        self.initShowToursFabToggle();

                        self.initHotelHotOffersSlider();
                    });

                    var resizeRaf = null;
                    window.addEventListener('resize', function () {
                        if (resizeRaf) {
                            cancelAnimationFrame(resizeRaf);
                        }
                        resizeRaf = requestAnimationFrame(function () {
                            _this2.initHotelInfoClamp();
                        });
                    });
                }
            }, {
                key: "initHotelHotOffersSlider",
                value: function initHotelHotOffersSlider() {
                    var _this3 = this;

                    var sliders = document.querySelectorAll('.js-hotel-hot-offers-swiper-desktop');
                    if (!sliders.length || typeof Swiper === 'undefined') {
                        return;
                    }

                    sliders.forEach(function (sliderElement) {
                        if (sliderElement.dataset.inited === '1') {
                            return;
                        }

                        sliderElement.dataset.inited = '1';

                        var swiper = new Swiper(sliderElement, {
                            slidesPerView: 'auto',
                            spaceBetween: 8,
                            speed: 450
                        });

                        _this3.hotelHotOffersSwipers.push(swiper);
                    });
                }
            }, {
                key: "openModal",
                value: function openModal() {
                    if (!this.modal || typeof this.modal.open !== 'function') return;

                    this.modal.open({
                        header: { title: '' },
                        content: { htmlDetachSelectorId: 'hotelMap' },
                        parentCssClass: 'desktop-hotel-map-modal',
                        footer: null,
                        type: 'floating',
                        onAfterShow: function onAfterShow() {
                            var element = document.querySelector('.btn-show-map');
                            var lat = +element.dataset.lat;
                            var lng = +element.dataset.lng;

                            var eventProperties = { Page: app.pageType };
                            window.brxTracking.sendAnalyticsEvent('click_map_hotel_page_open ', eventProperties);

                            mapModalInstance.handleMapModalClick({ lat: lat, lng: lng });
                        }
                    });
                }
            }, {
                key: "hotelServicesToggle",
                value: function hotelServicesToggle(element) {
                    var description = QS('#hotelDescriptionText');

                    if (!description) {
                        return;
                    }

                    if (!element) {
                        description.classList.remove('short');
                        return;
                    }

                    var items = QS('.hotel-services-items');

                    var currentText = element.textContent;
                    var newText = element.dataset.text;

                    element.dataset.text = currentText;
                    element.textContent = newText;

                    $toggleClass(description, 'short');

                    if (items) {
                        $toggleClass(items, 'hidden');
                    }
                }
            }, {
                key: "initHotelDescriptionClamp",
                value: function initHotelDescriptionClamp() {
                    var description = QS('#hotelDescriptionText');

                    if (!description) {
                        return;
                    }

                    var lineHeight = parseFloat(getComputedStyle(description).lineHeight);

                    if (!lineHeight || Number.isNaN(lineHeight)) {
                        return;
                    }

                    var linesCount = Math.ceil(description.scrollHeight / lineHeight);

                    if (linesCount > 5) {
                        description.classList.add('short');
                    } else {
                        description.classList.remove('short');
                    }
                }
            }, {
                key: "initHotelInfoClamp",
                value: function initHotelInfoClamp() {
                    var container = QS('.hotel-info-description.no-map');

                    if (!container) {
                        return;
                    }

                    var text = container.querySelector('.text');

                    if (!text) {
                        return;
                    }

                    var getOuterHeight = function getOuterHeight(element) {
                        if (!element) {
                            return 0;
                        }
                        var style = getComputedStyle(element);
                        var marginTop = parseFloat(style.marginTop) || 0;
                        var marginBottom = parseFloat(style.marginBottom) || 0;
                        return element.offsetHeight + marginTop + marginBottom;
                    };

                    var lineHeight = parseFloat(getComputedStyle(text).lineHeight);

                    if (!lineHeight || Number.isNaN(lineHeight)) {
                        return;
                    }

                    requestAnimationFrame(function () {
                        var title = container.querySelector('.page-title');
                        var button = container.querySelector('.js-show-hotel-description');
                        var beach = container.querySelector('.hotel-beach');

                        var occupiedHeight = getOuterHeight(title) + getOuterHeight(button) + getOuterHeight(beach);
                        var availableHeight = Math.max(container.clientHeight - occupiedHeight, lineHeight);
                        var clamp = Math.max(1, Math.floor(availableHeight / lineHeight));
                        text.style.setProperty('--hotel-info-line-clamp', clamp);
                    });
                }
            }, {
                key: "initShowToursFabToggle",
                value: function initShowToursFabToggle() {
                    var _this4 = this;

                    var fabButton = QS('.hotel-tours-fab');

                    if (!fabButton || typeof IntersectionObserver === 'undefined') {
                        return;
                    }

                    var setupObserver = function setupObserver(toursWrapper) {
                        if (!toursWrapper || _this4.showToursFabObserver) {
                            return;
                        }

                        var toursInView = true;
                        var updateVisibility = function updateVisibility() {
                            var hasTours = !!toursWrapper.querySelector('app-hotel-tour');
                            fabButton.classList.toggle('hidden', !hasTours || toursInView);
                        };

                        _this4.showToursFabObserver = new IntersectionObserver(function (entries) {
                            entries.forEach(function (entry) {
                                toursInView = entry.isIntersecting;
                                fabButton.classList.toggle('hotel-tours-fab--up', !toursInView && entry.boundingClientRect.top < 0);
                                updateVisibility();
                            });
                        }, {
                            root: null,
                            threshold: 0.1
                        });

                        _this4.showToursFabResultsObserver = new MutationObserver(updateVisibility);
                        _this4.showToursFabResultsObserver.observe(toursWrapper, {
                            childList: true,
                            subtree: true
                        });
                        updateVisibility();
                        _this4.showToursFabObserver.observe(toursWrapper);
                    };

                    var toursWrapper = document.querySelector('.ng-hotel-tours-wrapper');

                    if (toursWrapper) {
                        setupObserver(toursWrapper);
                        return;
                    }

                    if (typeof MutationObserver === 'undefined' || this.showToursFabInitObserver) {
                        return;
                    }

                    this.showToursFabInitObserver = new MutationObserver(function () {
                        var wrapper = document.querySelector('.ng-hotel-tours-wrapper');

                        if (!wrapper) {
                            return;
                        }

                        setupObserver(wrapper);

                        if (_this4.showToursFabInitObserver) {
                            _this4.showToursFabInitObserver.disconnect();
                            _this4.showToursFabInitObserver = null;
                        }
                    });

                    this.showToursFabInitObserver.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                }
            }, {
                key: "animateGradeBars",
                value: function animateGradeBars() {
                    document.querySelectorAll('.rating-grade-bar').forEach(function (bar) {
                        var target = parseFloat(bar.dataset.percent) || 0;
                        var percent = Math.min(Math.max(target, 0), 100);

                        // стартовое состояние
                        bar.style.setProperty('--w', '0%');

                        // запускаем анимацию после применения стилей
                        requestAnimationFrame(function () {
                            requestAnimationFrame(function () {
                                bar.style.setProperty('--w', percent + '%');
                            });
                        });
                    });
                }
            }]);

            return HotelPageDesktop;
        }();

        window.HotelPageDesktop = new HotelPageDesktop();
    }, {}] }, {}, [1]);